import ApiService from './ApiService';

export default class FileApi extends ApiService {
    getFolderIDCustomer(customerId) {
        return this.get(`customers/checkExistCustomerId/${encodeURIComponent(customerId)}`);
    }

    postNewFileUploaded(payload) {
        return this.post('files', payload);
    }

    getListFiles(payload) {
        return this.get('list-files', payload);
    }

    deleteFilesById(id: string) {
        return this.delete(`delete-file/${id}`);
    }

    checkFileExist(names: any) {
        return this.post('check-file-exist', names);
    }
}
